import React from "react";
import { useMediaQuery } from "react-responsive";

const testimonials = [
  {
    quote: "We saw 25% higher revenue and 38.41% GMV boost with KwikCheckout",
    name: "Vaishali Gupta",
    role: "Co-founder, mCaffeine",
    avatar: "./assets/images/checkout-v-one/macfinefounder.png",
    color: "#0012B7",
  },
];

const SectionOne: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { quote, name, role, avatar, color } = testimonials[0];

  return (
    <div
      className="sectionke-checkout-vone"
      style={{ minHeight: isMobile ? "50vh" : "90vh" }}
    >
      <div className="container-fluid p-0">
        <div className="row banner align-items-center">
          <div
            className="relative w-full max-w-5xl mx-auto"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* SVG Shape with content inside */}
            {!isMobile ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1067 440"
                preserveAspectRatio="xMidYMid meet"
                style={{ maxWidth: "1000px", height: "auto" }}
              >
                {/* Shape */}
                <path
                  d="M0.53125 20.0771C0.53125 9.03145 9.48556 0.0771484 20.5312 0.0771484H1046.53C1057.58 0.0771484 1066.53 9.03145 1066.53 20.0771V249.897C1066.53 260.943 1057.58 269.897 1046.53 269.897H763.531C752.486 269.897 743.531 278.852 743.531 289.897V419.897C743.531 430.943 734.577 439.897 723.531 439.897H342.531C331.486 439.897 322.531 430.943 322.531 419.897V291.711C322.531 280.712 313.65 271.777 302.651 271.711L20.4112 270.017C9.41252 269.951 0.53125 261.016 0.53125 250.017V20.0771Z"
                  fill={color}
                />

                {/* Content inside SVG */}
                <foreignObject
                  x="100"
                  y="40"
                  width="850"
                  height="360"
                  xmlns="http://www.w3.org/1999/xhtml"
                >
                  <div className="testi-content  text-center px-6 md:px-12">
                    {/* Quote */}
                    <h1 className="quote-testi">“{quote}”</h1>

                    {/* Avatar + Name + Role */}
                    <div className="" style={{ marginTop: "55px" }}>
                      <img
                        src={avatar}
                        alt={name}
                        className="founder-img rounded-full shadow-md"
                      />
                      <h4
                        className="mt-3 text-base md:text-2xl font-semibold"
                        style={{ fontSize: "28px" }}
                      >
                        {name}
                      </h4>
                      <p
                        className="text-sm md:text-base md:text-xl  opacity-80"
                        style={{ fontSize: "28px" }}
                      >
                        {role}
                      </p>
                    </div>
                  </div>
                </foreignObject>
              </svg>
            ) : (
              <div style={{maxWidth:"100%",marginTop:'100px'}}>
                <img  style={{maxWidth:'-webkit-fill-available',padding:' 0 10px'}} src="/assets/images/checkout-v-one/mob-sec1.png" alt="" />
              </div>

              // <div className="testi-content  text-center px-6 md:px-12 text-black" style={{color:'black',marginTop:"100px", }}>

              //   <h1 className="quote-testi">“{quote}”</h1>

              //   {/* Avatar + Name + Role */}
              //   <div className="" style={{ marginTop: "55px" }}>
              //     <img
              //       src={avatar}
              //       alt={name}
              //       className="founder-img rounded-full shadow-md"
              //     />
              //     <h4
              //       className="mt-3 text-base md:text-2xl font-semibold"
              //       style={{ fontSize: "28px" }}
              //     >
              //       {name}
              //     </h4>
              //     <p
              //       className="text-sm md:text-base md:text-xl  opacity-80"
              //       style={{ fontSize: "28px" }}
              //     >
              //       {role}
              //     </p>
              //   </div>
              // </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
